module.exports = __webpack_public_path__ + "img/SP1-C.3963d2d5.jpg";